import { axiosV2 } from "config/@axios";
import moment from "dayjs";

export const FETCH_STATISTICS = "statisticsActions::fetchStatistics";
export const FETCH_STATISTICS_SUCCESS =
  "statisticsActions::fetchStatisticsSuccess";
export const FETCH_STATISTICS_FAILED =
  "statisticsActions::fetchStatisticsFailed";
export const SET_SEARCH_PARAMS = "statisticsActions::setSearchParams";

export const fetchStatistics =
  (starttime = null, endtime = null, intervalType = null) =>
  dispatch => {
    dispatch({
      type: FETCH_STATISTICS
    });
    if (intervalType > 59) {
      intervalType = "month";
    } else if (intervalType > 30) {
      intervalType = "week";
    } else if (intervalType > 0) {
      intervalType = "day";
    } else {
      intervalType = "hour";
    }

    let url = "statistics";
    if (starttime) {
      url = `/statistics?starttime=${starttime}&endtime=${endtime}&interval=${intervalType}`;
    } else {
      url = `/statistics?starttime=${moment()
        .startOf("day")
        .unix()}&endtime=${moment().unix()}`;
    }

    return axiosV2
      .get(url)
      .then(response => {
        response.data.interval = intervalType;
        response.data.starttime = starttime;
        response.data.endtime = endtime;
        dispatch({
          type: FETCH_STATISTICS_SUCCESS,
          payload: {
            statistics: response.data
          }
        });
      })
      .catch(err => {
        dispatch({
          type: FETCH_STATISTICS_FAILED,
          payload: {
            errorMessage: err.errorMessage
          }
        });
      });
  };

export const setSearchParams = payload => {
  return {
    type: SET_SEARCH_PARAMS,
    payload
  };
};
